<div class="container" *ngIf="isDataAvailable">
  <!-- <h2 class="heading">{{ sitecoreContent.heading }}</h2> -->

  <!-- <p class="para">{{ sitecoreContent.text }} {{ validTime }} hours.</p> -->
  <div *ngIf="!submitted || email == ''; then thenBlock; else elseBlock"></div>
  <!-- <p class="para">{{ sitecoreContent.text }}</p> -->
  <ng-template #thenBlock class="para">{{ sitecoreContent.text }}</ng-template>
  <ng-template #elseBlock class="para"
    >Check {{ email }} for the email with a link to reset your
    password.</ng-template
  >
  <br /><br />

  <!-- <hr class="spacing" /> -->

  <form
    *ngIf="!submitted || email == ''"
    [formGroup]="forgotPassword"
    (ngSubmit)="onSubmit()"
  >
    <!-- <div class="frm-field">
      <label for="companyid"
        >{{ formFields?.companyField?.fieldInfo.label }}<span>*</span>:</label
      >
      <input
        class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
        type="text"
        id="companyid"
        formControlName="companyId"
        [ngClass]="{ 'is-invalid': submitted && f.companyId.errors }"
      />
      <div *ngIf="submitted && f.companyId.errors" class="invalid-feedback">
        <div *ngIf="f.companyId.errors.required">
          {{ formFields?.companyField?.fieldInfo.label }}
          {{ f.companyId['requiredError'] }}
        </div>
      </div>
    </div> -->
    <div class="frm-field">
      <label for="email"
        >{{ formFields?.emailField?.fieldInfo.label }}<span>*</span>:</label
      >
      <input
        class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
        type="email"
        id="email"
        formControlName="email"
        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
      />
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">
          {{ formFields?.emailField?.fieldInfo.label }}
          {{ f.email['requiredError'] }}
        </div>
        <div *ngIf="f.email.errors.email">
          {{ f.email['validEmailError'] }}
        </div>
      </div>
    </div>

    <div class="frm-field">
      <label for="confirmemail"
        >{{ formFields?.verifyEmailField?.fieldInfo.label
        }}<span>*</span>:</label
      >
      <input
        class="form-control ng-untouched ng-pristine ng-invalid is-invalid"
        type="email"
        id="confirmemail"
        formControlName="confirmEmail"
        [ngClass]="{
          'is-invalid': submitted && f.confirmEmail.errors
        }"
      />
      <div *ngIf="submitted && f.confirmEmail.errors" class="invalid-feedback">
        <div *ngIf="f.confirmEmail.errors.required">
          {{ formFields?.verifyEmailField?.fieldInfo.label }}
          {{ f.confirmEmail['requiredError'] }}
        </div>
        <div
          *ngIf="f.confirmEmail.value !== f.email.value && f.confirmEmail.value"
        >
          {{ f.confirmEmail['matchError'] }}
        </div>
      </div>
    </div>

    <div>
      <button type="button" class="cancel btn-secondary" (click)="cancel()">
        CANCEL
      </button>
      <button class="btn-primary send">SEND EMAIL</button>
    </div>
  </form>
</div>
<div class="footer-line"></div>
